import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import about1 from '../../images/aboutimg.png';
import about2 from '../../images/about/about_image_11.webp'
import about3 from '../../images/about/about_image_10.webp'

const About = (props) => {

    const [isOpen, setOpen] = useState(false)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="about_section section_space">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                          <img src={about1} alt="Techco - About" />
                    </div>
                    <div className="col-lg-6">
                        <h1>Welcome to Hotel Ex.</h1>
                        <h4 style={{marginBottom:'30px'}}>Simple, yet powerful software <br/> for your small property.</h4>
                        <p>We designed our hotel management software for busy people just like you.</p>
                        <p>Who not only have a property to manage, but a big day — every single day.</p>
                        <p>Little Hotelier doesn’t just boost your bookings, it gives you more control and freedom, too.</p>

                        <Link className="btn" to="/pricing">
                            <span className="btn_label" data-text="Try Free For 14 Days">Try Free For 14 Days</span>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;